/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum Action {
  ToAdd = 'To Add',
  ToUpdate = 'To Update',
  ToDelete = 'To Discontinue',
  ToChangeState = 'To change state',
  AddedByAnotherUser = 'Assigned by another user'

}
